import { createRoutine } from "redux-saga-routines";

const Logout = createRoutine("LOGOUT");
const GetMe = createRoutine("GET_ME");
const SetToken = createRoutine("SET_TOKEN");

export default {
    Logout,
    GetMe,
    SetToken
};
